export default __webpack_public_path__ + "static/media/img1.107994d8.jpg";